import { ShippingTierService } from "../resource";

const ShippingTierModule = {
    namespaced: true,
    state: {
        list: [],
        total: 0,
        loading: false,
        error: null,
        current: null
    },
    mutations: {
        SET_LIST(state, data) {
            state.list = data;
        },
        SET_TOTAL(state, total) {
            state.total = total;
        },
        SET_LOADING(state, val) {
            state.loading = val;
        },
        SET_ERROR(state, err) {
            state.error = err;
        },
        SET_CURRENT(state, item) {
            state.current = item;
        }
    },
    actions: {
        async fetchList({ commit }, params) {
            commit("SET_LOADING", true);
            commit("SET_ERROR", null);
            try {
                const res = await ShippingTierService.list(params);
                const data = (res.data && res.data.data) ? res.data.data : [];
                commit("SET_LIST", data);
                commit("SET_TOTAL", data.length);
            } catch (err) {
                commit("SET_LIST", []);
                commit("SET_ERROR", err);
            } finally {
                commit("SET_LOADING", false);
            }
        },
        create(_, payload) {
            return ShippingTierService.create(payload);
        },
        update(_, { id, payload }) {
            return ShippingTierService.update(id, payload);
        },
        remove(_, id) {
            return ShippingTierService.remove(id);
        }
    },
    getters: {
        list: state => state.list,
        total: state => state.total,
        loading: state => state.loading,
        error: state => state.error,
        current: state => state.current
    }
};

export default ShippingTierModule;
